/** ScrollSpy section indices — keep in sync with `sectionData` order in `page.tsx`. */
export const REGULAMIN_SECTION_INDEX = {
  paymentRules: 6,
  complaints: 7
} as const

export function regulaminSectionHref(
  section: keyof typeof REGULAMIN_SECTION_INDEX
): `/regulamin#${number}` {
  return `/regulamin#${REGULAMIN_SECTION_INDEX[section]}`
}
